<template>
    <div></div>
</template>

<script setup lang="ts">
import { defineComponent, getCurrentInstance } from 'vue';
import { useMessage } from 'naive-ui';
window.$message = useMessage()
</script>